import { handleActions } from 'redux-actions';
import * as actions from './actions';
import { resetForm } from "../create-llama/actions";

const defaultState = {
  isMediaStreamFailed: false,

  isRecording: false,
  isStopped: false,
  isPlaying: false,

  isConverting: false,
  convertError: null,

  originVideoPath: null,
  originVideoInfo: null,
  resultVideoPath: null,
  resultVideoBlob: null,
  resultPreviewPath: null,
  resultPreviewBlob: null,
  duration: null,

  layoutSize: null
};

const reducer = handleActions(
  new Map([
    [actions.recordVideo,
      (state, action) => {
        return {
          ...state,
          isRecording: true,
          isStopped: false,
          isPlaying: false,
          codec: null,

          originVideoPath: null,
          originVideoInfo: null,
          resultVideoPath: null,
          resultPreviewPath: null,
        };
      }],
    [actions.setOriginVideo,
      (state, action) => {
        return {
          ...state,
          isPlaying: true,
          isStopped: false,
          originVideoPath: action.payload.uri,
          resultVideoBlob: action.payload.blob
        };
      }],
    [actions.setOriginVideoInfo,
      (state, action) => {
        return {
          ...state,
          originVideoInfo: action.payload
        };
      }],
    [actions.setResultVideo,
      (state, action) => {
        return {
          ...state,
          isPlaying: true,
          isStopped: false,
          resultVideoPath: action.payload.uri,
          resultPreviewPath: action.payload.previewUri,
          resultPreviewBlob: action.payload.previewBlob
        };
      }],
    [actions.stopPlaying,
      (state, action) => ({ ...state, isPlaying: false, isStopped: true })],
    [actions.startPlaying,
      (state, action) => ({ ...state, isPlaying: true, isStopped: false })],
    [actions.resetState,
      (state, action) => ({...defaultState})],

    // Convert video request
    [actions.convertVideoRequest,
      (state, action) => ({ ...state, isConverting: true, isRecording: false })],
    [actions.convertVideoSuccess,
      (state, action) => ({ ...state, isConverting: false, convertError: null })],
    [actions.convertVideoFailed,
      (state, action) => ({ ...state, isConverting: false, convertError: action.payload })],

    // Set layout size
    [actions.setLayoutSize,
      (state, action) => ({ ...state, layoutSize: action.payload })],

    // reset
    [resetForm, (state, action) => {
      return { ...defaultState };
    }],
    [actions.restoreVideo, (state, action) =>  action.payload],

    [actions.mediaStreamFailed, (state, action) => ({ ...state, isMediaStreamFailed: true })],
  ]),
  defaultState
);

export default reducer;